import { IVideoPlayerProvider } from "./interfaces/video-player-provider";
import { vimeoProvider } from "./vimeo-provider.component";
import { youtubeProvider } from "./youtube-provider.component";

/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-return */

export class VideoBoxComponent {
    private _currentContext: JQuery = $();

    private moduleOptions = {};

    private classMap = {
        videoFrame: ".js-video-box__frame",
        playButton: ".js-video-box__play-button"
    };

    private $frame: JQuery = $();
    private $playButton: JQuery = $();
    private player!: unknown;
    private provider!: IVideoPlayerProvider;

    private subscriptions: Record<string, Array<any>> = {};

    public static init(context: JQuery, options: JQuerySlickOptions | object): VideoBoxComponent {
        const videoBox = new VideoBoxComponent();
        videoBox.init(context, options);
        return videoBox;
    }

    public init(context: JQuery, options: object): void {
        this._currentContext = context || this._currentContext;
        $.extend(this.moduleOptions, options);

        this.parseContext();

        const frameId = this.$frame.attr("id");
        if (!frameId) {
            return;
        }

        this.provider = this.getProvider();
        this.setVideoUrl();

        void this.createPlayer().then(() => {
            this.bindEvents();
        });
    }

    private parseContext(): void {
        this.$frame = $(this.classMap.videoFrame, this._currentContext);
        this.$playButton = $(this.classMap.playButton, this._currentContext);
    }

    private getProvider(): IVideoPlayerProvider {
        const provider = this.$frame.data("provider");
        switch (provider) {
            case "vimeo": {
                return vimeoProvider;
            }
            case "youtube": {
                return youtubeProvider;
            }
            default: {
                // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
                throw new Error(`Provider "${provider}" is not supported`);
            }
        }
    }

    private setVideoUrl(): void {
        const autoplay = this.$frame.data("autoplay") as boolean;
        const videoId = this.$frame.data("video-id") as string;

        const videoUrl = this.provider.getEmbedUrl(videoId, true, !!autoplay);

        this.$frame.attr("src", videoUrl);
    }

    private createPlayer(): Promise<unknown> {
        return new Promise((resolve) => {
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const createPlayerPromise = this.provider.createPlayer(this.$frame.attr("id")!);

            void createPlayerPromise.then((instance) => {
                this.player = instance;
                resolve(instance);
            });
        });
    }

    private bindEvents(): void {
        this.$playButton.on("click", () => {
            this.raiseEvent("play-button-click");
        });
    }

    public on(event: string, handler: any): void {
        if (this.subscriptions.hasOwnProperty(event)) {
            this.subscriptions[event].push(handler);
        } else {
            this.subscriptions[event] = [handler];
        }
    }

    private raiseEvent(event: string, data: any = null): void {
        const handlers = this.subscriptions[event];
        if (handlers) {
            handlers.forEach(handler => handler(data));
        }
    }
}
